export const TOGGLE_RIGHT_MENU = 'App/Page::TOGGLE_RIGHT_MENU';
export const TOGGLE_LEFT_MENU = 'App/Page::TOGGLE_LEFT_MENU';
export const OPEN_VERIFY_MODAL = 'App/Page::OPEN_VERIFY_MODAL';
export const VERIFY_PERSON_FORM = 'App/Page::VERIFY_PERSON_FORM';
export const CLOSE_CONFIRM = 'App/Page::CLOSE_CONFIRM';
